import React, {useState,useEffect} from 'react';
import './Signin.css';
import { db } from "../../../../config/firebase";
import {useForm} from 'react-hook-form'
import {yupResolver} from '@hookform/resolvers/yup'
import * as yup from 'yup'
import { Link, useHistory } from 'react-router-dom';


const schema = yup.object({
  Name : yup.string().required(),
  Email : yup.string().email().required(),
  Contact : yup.string().length(10).required(),
  Age : yup.number().min(1).max(60).positive().integer().required(),
  Company : yup.string().required(),
  Role : yup.string().required() 
}).required()



const Signin = () => {

  const history = useHistory()

  useEffect(()=>{
    window.scrollTo(0,0)
  },[])

  const [success,setSuccess] = useState(false)

  const {register,handleSubmit,formState:{errors}} = useForm({
    resolver : yupResolver(schema)
  })

  const onSubmit = (data) => {
    db.collection("tests")
    .add(data)
    .then(() => {
      setSuccess(true)
      history.push('/tests')
    })
    .catch((error) => {
      alert(error.message);
    });

    window.scrollTo(0,0)
  }

  return (
    <>
    <div className='form-container'> 
    <form className="form" onSubmit={handleSubmit(onSubmit)}>
      {
        success ?
       <Link to='/tests'>
       <div>
        </div>
       </Link> 
        :
        <>
        <h3 style={{textAlign:'center'}}>Fill your Credentials</h3> 
        <div className='form-item'>
          <label>Full name <span style={{color:'red'}}>*</span></label>
          <input type="text" className='form-input' placeholder="Enter full name" name="Name" 
          {...register("Name")}/>
          <div style={{fontSize:'2vh',color:'red',marginTop:'0.5vh'}}>{errors.Name?.message}</div>
        </div>

        <div className='form-item'>
          <label  className='form-item'>Email <span style={{color:'red'}}>*</span></label>
          <input type="text" className='form-input' placeholder="Enter email address" name="Email" 
          {...register("Email")}/>
          <div style={{fontSize:'2vh',color:'red',marginTop:'0.5vh'}}>{errors.Email?.message}</div>
        </div>

        <div className='form-item'>
          <label  className='form-item'> Contact Number <span style={{color:'red'}}>*</span> </label>
          <input type="text" className='form-input' placeholder="Enter phone number" name="Contact" 
          {...register("Contact")}/>
          <div style={{fontSize:'2vh',color:'red',marginTop:'0.5vh'}}>{errors.Contact?.message}</div>
        </div>

        <div className='form-item'>
          <label className='form-item'> Age <span style={{color:'red'}}>*</span></label>
          <input type="text" className='form-input' placeholder="Enter age" name="Age" 
          {...register("Age")}/>
          <div style={{fontSize:'2vh',color:'red',marginTop:'0.5vh'}}>{errors.Age?.message}</div>
        </div>

        <div className='form-item'>
          <label className='form-item'> Profession <span style={{color:'red'}}>*</span></label>
          <input type="text" className='form-input' placeholder="Enter profession" name="Profession" 
          {...register("Profession")}/>
          <div style={{fontSize:'2vh',color:'red',marginTop:'0.5vh'}}>{errors.Profession?.message}</div>
        </div>

        <div className='form-item'>
          <label className='form-item'> Profile <span style={{color:'red'}}>*</span></label>
          <input type="text" className='form-input' placeholder="Enter your profile/role in company" name="Role" 
          {...register("Role")}/>
          <div style={{fontSize:'2vh',color:'red',marginTop:'0.5vh'}}>{errors.Role?.message}</div>
        </div>
        
        <div className='form-item'> 
          <button className='form-button'> Give Tests </button>
        </div>
        </>
      }
    </form>
  </div>
    </>
  );
};

export default Signin;